// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mixin-components-container[data-v-55b409ce]{background-color:#f0f2f5;padding:30px;min-height:calc(100vh - 84px)}.component-item[data-v-55b409ce]{min-height:100px}", ""]);
// Exports
module.exports = exports;
